export default[
    {
        name:"Area",
        path:"/Serve/Area",
        component:() => import("@/view/Serve/area"),
        meta:{
            title:"全部",
        }
    },
    {
        name:"SouthChina",
        path:"/Serve/SouthChina",
        component:() => import("@/view/Serve/southChina"),
        meta:{
            title:"华南区",
        }
    },
    {
        name:"NorthChina",
        path:"/Serve/NorthChina",
        component:() => import("@/view/Serve/northChina"),
        meta:{
            title:"华北区",
        }
    },
    {
        name:"CentralChina",
        path:"/Serve/CentralChina",
        component:() => import("@/view/Serve/centralChina"),
        meta:{
            title:"华中区",
        }
    },
    {
        name:"EastChina",
        path:"/Serve/EastChina",
        component:() => import("@/view/Serve/eastChina"),
        meta:{
            title:"华东区",
        }
    },
    {
        name:"WesternChina",
        path:"/Serve/WesternChina",
        component:() => import("@/view/Serve/westernChina"),
        meta:{
            title:"华西区",
        }
    },
]